import { render, staticRenderFns } from "./CaykaCaseStudy.vue?vue&type=template&id=7fb40529&scoped=true"
import script from "./CaykaCaseStudy.vue?vue&type=script&lang=js"
export * from "./CaykaCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./CaykaCaseStudy.vue?vue&type=style&index=0&id=7fb40529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb40529",
  null
  
)

export default component.exports